import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Link,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { ZonaOptions } from '../../../../helpers';
import { StoricoUfficioComuneCompetenzaContext } from '../StoricoUfficioComuneCompetenzaContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const UfficioDetails = ({
    disabled,
    formRef,
    onActionClick,
    ...props
}) => {

    const {
        state,
        setState,
    } = useContext(StoricoUfficioComuneCompetenzaContext);

    const {
        storicoUfficioComuneCompetenza
    } = state;


    const buildTableCellRowComponent = (key, value, oldValue) => {
        return (<TableRow>
            <TableCell style={{ width: "20%" }}>
                {key}
            </TableCell>
            <TableCell>
                <div>
                    {value ?? '-'}
                </div>
                {(value != oldValue ? <div style={{
                    //backgroundColor: 'rgba(255, 0, 0, 0.6)',
                    textDecoration: 'line-through',
                    color: 'red'
                }}>
                    {oldValue ?? '-'}
                </div> : <div />)}
            </TableCell>
        </TableRow>);
    }


    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                    aria-controls="ufficio-panel"
                    id="ufficio-panel"
                    sx={{
                        color: "white",
                        backgroundColor: "secondary.main",
                    }}
                >
                    <Typography variant="h6">Ufficio</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                    <Table>
                        <TableBody>
                            {buildTableCellRowComponent("Nome", storicoUfficioComuneCompetenza?.valore.Ufficio?.Nome, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.Nome)}
                            {buildTableCellRowComponent("Comune", storicoUfficioComuneCompetenza?.valore.Ufficio?.Comune?.DenominazioneIt, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.Comune?.DenominazioneIt)}
                            {buildTableCellRowComponent("Tipo", storicoUfficioComuneCompetenza?.valore.Ufficio?.TipoUfficio?.Nome, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.TipoUfficio?.Nome)}
                            {buildTableCellRowComponent("Codice ufficio", storicoUfficioComuneCompetenza?.valore.Ufficio?.CodiceUfficio, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.CodiceUfficio)}
                            {buildTableCellRowComponent("Code new", storicoUfficioComuneCompetenza?.valore.Ufficio?.CodeNew, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.CodeNew)}
                            {buildTableCellRowComponent("Codice istat ubicazione", storicoUfficioComuneCompetenza?.valore.Ufficio?.CodiceIstatUbicazione, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.CodiceIstatUbicazione)}
                            {buildTableCellRowComponent("Msg", storicoUfficioComuneCompetenza?.valore.Ufficio?.Msg, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.Msg)}
                            {buildTableCellRowComponent("Status", storicoUfficioComuneCompetenza?.valore.Ufficio?.Status, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.Status)}
                            {buildTableCellRowComponent("Cap", storicoUfficioComuneCompetenza?.valore.Ufficio?.Cap, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.Cap)}
                            {buildTableCellRowComponent("Codice fiscale", storicoUfficioComuneCompetenza?.valore.Ufficio?.CodiceFiscale, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.CodiceFiscale)}
                            {buildTableCellRowComponent("Festività", storicoUfficioComuneCompetenza?.valore.Ufficio?.Patrono, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.Patrono)}
                            {buildTableCellRowComponent("Indirizzo", storicoUfficioComuneCompetenza?.valore.Ufficio?.Indirizzo, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.Indirizzo)}
                            {buildTableCellRowComponent("Lingue parlate", storicoUfficioComuneCompetenza?.valore.Ufficio?.LingueParlate, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.LingueParlate)}
                            {buildTableCellRowComponent("VideoConferenza", storicoUfficioComuneCompetenza?.valore.Ufficio?.VideoConferenza, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.VideoConferenza)}
                            {buildTableCellRowComponent("Altre sedi", storicoUfficioComuneCompetenza?.valore.Ufficio?.AltreSedi, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.AltreSedi)}
                            {buildTableCellRowComponent("Informazioni", storicoUfficioComuneCompetenza?.valore.Ufficio?.InfoAggiuntive, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.InfoAggiuntive)}
                            {buildTableCellRowComponent("Latitudine", storicoUfficioComuneCompetenza?.valore.Ufficio?.Latitudine, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.Latitudine)}
                            {buildTableCellRowComponent("Longitudine", storicoUfficioComuneCompetenza?.valore.Ufficio?.Longitudine, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.Longitudine)}
                            {buildTableCellRowComponent("Zona", ZonaOptions.find(e => e.zona == storicoUfficioComuneCompetenza?.valore.Ufficio?.zona)?.label, ZonaOptions.find(e => e.zona == storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.zona)?.label)}
                            {buildTableCellRowComponent("Zona riferimento", storicoUfficioComuneCompetenza?.valore.Ufficio?.ZonaRiferimento, storicoUfficioComuneCompetenza?.valorePrecedente.Ufficio?.ZonaRiferimento)}
                        </TableBody>
                    </Table>
                </AccordionDetails>
            </Accordion>
        </>
    );
}